import React, { useState } from 'react';
import { Button, Dialog, DialogContent, Divider, Grid, makeStyles, Typography } from '@quillbot/design-system';
import Link from 'next/link';
import getConfig from 'next/config';
import Track from 'core/logger/track';
import { useRouter } from 'next/router';
import Img from '@Common/components/img';

const { publicRuntimeConfig } = getConfig();

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#000000A6',
  },
  paper: {
    width: '485px',
    height: '510px',
    borderRadius: '8px',
  },
  getStartedBtn: {
    borderRadius: '100px',
    width: '300px',
    fontSize: '16px',
    fontWeight: 600,
    height: '50px',
    marginBottom: '20px',
  },

  title: {
    fontSize: '24px',
    fontWeight: 600,
    textAlign: 'center',
    marginBottom: '11px',
  },

  captionText: {
    width: '300px',
    marginTop: '11px',
    marginBottom: '24px',
    fontWeight: 600,
    fontSize: '12px',
    textAlign: 'center',
    color: '#828282',
  },
  bottomText: {
    fontWeight: 600,
    fontSize: '10px',
    marginTop: '12px',
    color: '#505050',
    textAlign: 'center',
    padding: '2px',
  },
}));

interface UpdatedChromeExtProps {
  setShowUpdatedModal: React.Dispatch<React.SetStateAction<boolean>>;
}

function UpdatedChromeExtModal(props: UpdatedChromeExtProps) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const router = useRouter();

  const handleClose = () => {
    const actionName = 'chrome-active/system/clicked_privacy_prompt';
    Track.getInstance().storeActionEvent(actionName, {
      triggeredBy: 'onboarding',
      prevVersion: router.query.prevVersion,
    });
    Track.getInstance().ampEvent(actionName, {
      triggeredBy: 'onboarding',
      prevVersion: router.query.prevVersion,
    });
    try {
      chrome?.runtime?.sendMessage(
        publicRuntimeConfig.CHROME_EXTENSION_ID,
        { action: 'privacy-policy-verified' },
        () => {
          if (chrome?.runtime?.lastError) {
            console.log('error updating privacy policy');
          }
        }
      );
    } catch (e) {
      console.error(e);
    }
    props.setShowUpdatedModal(false);
    setOpen(false);
  };

  return (
    <Dialog
      fullWidth
      open={open}
      classes={{
        paper: classes.paper,
        root: classes.root,
      }}
      aria-labelledby="Premium Features"
      aria-describedby="Dialog box explaining premium features">
      <DialogContent>
        <Grid container>
          <Typography className={classes.title}>QuillBot for Chrome updated successfully!</Typography>
          <Grid container item justifyContent="center">
            <Grid
              item
              style={{
                width: '25rem',
                height: '15rem',
                overflow: 'hidden',
                marginBottom: '24px',
              }}>
              <Img
                src="/images/commonImages/onboardingEducation.png"
                alt="sidebar onboarding education gif"
                style={{
                  width: '25rem',
                }}
              />
            </Grid>

            {/* <Typography className={classes.captionText}>
              You can access the old extension by clicking on the{' '}
              <span style={{ color: '#252525' }}>QuillBot Sidebar</span> in the menu.
            </Typography> */}
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Button variant="outlined" color="primary" className={classes.getStartedBtn} onClick={handleClose}>
            Enable & View Extension Upgrades
          </Button>
          <Divider
            variant="fullWidth"
            style={{
              //   margin: '15px -8px 4px -8px',
              width: '111%',
              height: '1px',
              color: '#252525',
            }}
          />
          <Typography className={classes.bottomText}>
            We do not save any of your text on our servers. The extension will process your text by sending it to
            QuillBot.com over an encrypted connection. For more details, see{' '}
            <Link href="/privacy">
              <a rel="noopener noreferrer" target="_blank">
                our privacy policy
              </a>
            </Link>
          </Typography>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default UpdatedChromeExtModal;
